import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import GoogleCustomerReviewsOptIn from '../components/GoogleCustomerReviewsOptIn';
import { readLastOrder, buildWhatsAppOrderMessage } from '../utils/orderCompletion';
import './OrderConfirmation.css';

const WHATSAPP_NUMBER = '254708177021';

const OrderConfirmation = ({ navigate }) => {
  const location = useLocation();
  const order = useMemo(
    () => location.state?.order || readLastOrder(),
    [location.state]
  );

  if (!order?.orderId) {
    return (
      <div className="order-confirmation-page">
        <div className="order-confirmation-container order-confirmation-empty">
          <h1>No order found</h1>
          <p>We could not find a recent order confirmation.</p>
          <Link to="/" className="order-confirmation-btn primary">Back to home</Link>
        </div>
      </div>
    );
  }

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    buildWhatsAppOrderMessage(order)
  )}`;

  const needsWhatsApp = order.paymentMethod === 'whatsapp';

  return (
    <div className="order-confirmation-page">
      <GoogleCustomerReviewsOptIn order={order} />
      <div className="order-confirmation-container">
        <div className="order-confirmation-card">
          <h1 className="order-confirmation-title">Thank you for your order</h1>
          <p className="order-confirmation-subtitle">
            {needsWhatsApp
              ? 'Your order details are saved. Send them on WhatsApp so our team can confirm delivery.'
              : 'Your order has been received. We will contact you shortly to confirm delivery.'}
          </p>
          <div className="order-confirmation-ref">Order reference: {order.orderId}</div>

          <div className="order-confirmation-summary">
            <h2>Order summary</h2>
            {(order.items || []).map((item) => (
              <div key={item.id || item._id || item.name} className="order-confirmation-line">
                <span>{item.name} × {item.quantity}</span>
                <strong>
                  Ksh {(item.price * item.quantity).toLocaleString('en-KE')}
                </strong>
              </div>
            ))}
            <div className="order-confirmation-line">
              <span>Delivery ({order.deliveryOption})</span>
              <strong>
                {order.deliveryCost === 0
                  ? 'Pending confirmation'
                  : `Ksh ${Number(order.deliveryCost).toLocaleString('en-KE')}`}
              </strong>
            </div>
            <div className="order-confirmation-line order-confirmation-total">
              <span>Total</span>
              <strong>Ksh {Number(order.total || 0).toLocaleString('en-KE')}</strong>
            </div>
          </div>

          {!order.email && (
            <p className="order-confirmation-note">
              Add your email at checkout next time to receive order updates and optional Google
              customer feedback surveys.
            </p>
          )}

          <div className="order-confirmation-actions">
            {needsWhatsApp && (
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="order-confirmation-btn whatsapp"
              >
                Send order on WhatsApp
              </a>
            )}
            <button
              type="button"
              className="order-confirmation-btn primary"
              onClick={() => navigate('/')}
            >
              Continue shopping
            </button>
            <button
              type="button"
              className="order-confirmation-btn secondary"
              onClick={() => navigate('/help')}
            >
              Help centre
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
